import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetMyStore = (isFetch = true) => {
	const [fetchResult, fetchRequest] = useFetch()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		if (isFetch) {
			fetchRequest('GET', `/${rolePath}/store/my`)
		}
	}, [isFetch])

	return [fetchResult]
}

export default useGetMyStore
